import React , { useEffect, useState } from 'react'
import moment from 'moment'
import { useTranslation } from 'react-i18next';
function MiseADispoHorizontal({
	commande,
	onClickDetails = () => {},
	onClickSignaler = () => {},
	onClickAccept = () => {},
	onClickRecu = () => {},
	onClickAttribuer = () => {},
	onClickRefuser=()=>{},
	hideStatus = false,
	hideAccept = true,
	hideRecu = false,
	hideSignaler,
	hideAttribuer = false,
	hideTarif = false,	
}) {
   
	const findClosestMission = (missions) => {
		const validMissions = missions
			.filter(mission => mission.statut !== "annuler") 
			.sort((a, b) => { 
				const aDateTime = moment(`${a.date_debut} ${a.heure_debut}`, "DD/MM/YYYY HH:mm");
				const bDateTime = moment(`${b.date_debut} ${b.heure_debut}`, "DD/MM/YYYY HH:mm");
				return aDateTime - bDateTime;
			});
	
		if (validMissions.length === 0){
			const sortedAnnulerMissions=missions
			.sort((a, b) => { 
				const aDateTime = moment(`${a.date_debut} ${a.heure_debut}`, "DD/MM/YYYY HH:mm");
				const bDateTime = moment(`${b.date_debut} ${b.heure_debut}`, "DD/MM/YYYY HH:mm");
				return aDateTime - bDateTime;
			});
			return sortedAnnulerMissions[0]
		}
	
		return validMissions[0];
	};
	
	const closestMission = findClosestMission(commande?.missions);
	
	// Calculate additional costs (difference between prix_total and initial price )
	 const additionalCosts = (commande?.prix_total || 0) - (commande?.prix || 0);

	const findLatestMission = (missions) => {
		const validMissions = missions
			.filter(mission => mission.statut !== "annuler") 
			.sort((a, b) => { 
				const aDateTime = moment(`${a.date_fin} ${a.heure_fin}`, "DD/MM/YYYY HH:mm");
				const bDateTime = moment(`${b.date_fin} ${b.heure_fin}`, "DD/MM/YYYY HH:mm");
				return bDateTime - aDateTime;
			});
	
		if (validMissions.length === 0) {
			const sortedAnnulerMissions=missions
			.filter(mission => mission.statut !== "annuler") 
			.sort((a, b) => { 
				const aDateTime = moment(`${a.date_fin} ${a.heure_fin}`, "DD/MM/YYYY HH:mm");
				const bDateTime = moment(`${b.date_fin} ${b.heure_fin}`, "DD/MM/YYYY HH:mm");
				return bDateTime - aDateTime;
			});
			return sortedAnnulerMissions[0]
		}
	
		return validMissions[0];
	};
	const latestMission = findLatestMission(commande?.missions);

	

	



   const totalForfaitsSupp = commande.missions
    .filter(mission => mission.statut !== 'annuler')
    .reduce((total, mission) => {
        const totalForfaitsMission = mission.forfaits
            ?.reduce((totalForfait, forfait) => totalForfait + (forfait.prix || 0), 0) || 0;
        
        return total + totalForfaitsMission;
    }, 0);
   


	const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
		 const [isTablette, setIsTablette] = useState(() => window.innerWidth < 1024 &&  window.innerWidth > 768);
	
		useEffect(() => {
			const checkScreen = () => {
				const width = window.innerWidth;
	
		setIsMobile(width <= 768);
    setIsTablette(width > 768 && width <= 1024);
			};
			checkScreen(); 
			window.addEventListener('resize', checkScreen);
	
			return () => window.removeEventListener('resize', checkScreen);
		}, []);
	
    const {t} = useTranslation()
	return (
		<div
			style={{
				width: '100%',
				background: '#E4EAF0',
				display: 'flex',
				flexDirection: isMobile ? 'column' : 'row',
				padding: '1rem',
				borderRadius: 10,
				alignItems: 'flex-start',
				justifyContent: 'space-between',
				marginBottom: 10,
				gap : '10px'
			}}
		>
			<div
			style={{
				display: 'flex',
				flexDirection: isMobile || isTablette ? 'column' : 'row',
				gap: '10px'
			}}
			>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					fontSize: 13,
				}}
			>
				<span
					style={{
						fontWeight: 'bold',
						color: '#51C7F2',
						marginBottom: 3,
					}}
				>
					{t("mise_à_disposition")} {!!commande ? 'N°' + commande.__id : '' } /{' '}
					<span style={{ color: '#1C63C5' }}>
						{commande.temporisation === 'immediat'
							? t("immédiate")
							: t("planifiée")}
					</span>
				</span>
                <div 
				style={{
					display: 'flex',
					flexDirection: 'row'
				}}>
				<span
					style={{
						color: '#838EAB',
						marginBottom: '1rem',


					}}
				>
					{t("transport_date")} :{' '}
					<span
						style={{
							marginRight: 13,
							color: 'red',

						}}
					>
					<span
											style={{
												marginRight: 15,
												color: '#838EAB',
												fontWeight: 'bolder'
											}}
										>
											{moment(commande.date_transport).format('DD/MM/YYYY')}
										</span>
				</span>
				</span>
				
				</div>
				
                <span
					style={{
						color: '#838EAB',
						width: '15rem',
						marginBottom: '1rem',

					}}
				>
					{t("creation_date")} :{' '}
					<span
						style={{
							marginRight: 13,
							color:'red'
						}}
					>
				    <span
											style={{
												marginRight: 15,
												color: '#838EAB',
												fontWeight: 'bolder'
											}}
										>
											{moment(commande.createdAt).format('DD/MM/YYYY')}
										</span>
					</span>
				</span>
				<span
					style={{
						marginRight: 13,
						marginBottom: '1rem',
						color: '#838EAB',
						width: '15rem',

					}}
				>
          {t("start_date")} : {' '}
		  <span 
		  style={{marginRight: 15,
												color: '#838EAB',
												fontWeight: 'bolder'
           }}>
		   {closestMission?.date_debut}{' '}
           {closestMission?.heure_debut}{' '}
           {closestMission?.adresse_debut?.label}
		  </span>
		 
				</span>

				<span
					style={{
						marginRight: 13,
						color: '#838EAB',
						width: '15rem',

					}}
				>
					 {t("end_date")}:{' '}
					 <span 
					  style={{marginRight: 15,
												color: '#838EAB',
												fontWeight: 'bolder'
						 }}>
					{latestMission?.date_fin}{' '}
                    {latestMission?.heure_fin}{' '}
                    {latestMission?.adresse_fin?.label}
					 </span>
					
				</span>
                <span
					style={{
						color: '#838EAB',
						width: '15rem',
						marginTop: 10,

					}}
				>
					 {t("payment_status")} :{' '}
					<span
						style={{
							marginRight: 15,
												color: '#838EAB',
												fontWeight: 'bolder'
						}}
					>
				 {commande.paymentStatus==='payé' ? t("paid") : t("unpaid" )}

					</span>
				</span>
				<span
					style={{
						color: '#838EAB',
						width: '15rem',
						marginTop: 10,

					}}
				>
					 {t("order_status")} :{' '}
					<span
						style={{
							marginRight: 15,
												color: '#838EAB',
												fontWeight: 'bolder'
						}}
					>
                    {commande?.statut==="init" && t("not_started")}
                    {commande?.statut==="en-cours" && t("in_progress")}
                    {commande?.statut==="terminer" && t("completed")}
                   {commande?.statut==="annuler" && t("cancelled")}
					</span>
				</span>
				<span
					style={{
						color: '#838EAB',
						marginTop: 10,

					}}
				>
					{t("number_of_missions")}: {' '}
					<span style={{marginRight: 15,
												color: '#838EAB',
												fontWeight: 'bolder'}}>
					{commande?.missions?.length}
					</span>
					
				</span>
        
			</div>

			{/*  */}

			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					fontSize: 13,
					height: '100%',

				}}
			>
				<span
					style={{
						color: '#838EAB',
						marginBottom: '1rem',

					}}
				>
					{t("number_of_loaders")} :{' '}
					<span style={{ marginRight: 15,
												color: '#838EAB',
												fontWeight: 'bolder'}}>
					{commande.statut!=="annuler" ?(commande?.missions
                    ?.filter(mission => mission.statut !== "annuler")
                    ?.reduce((total, mission) => total + (mission?.nombre_rippeur || 0), 0) || 0)
				    :
					(commande?.missions
						?.reduce((total, mission) => total + (mission?.nombre_rippeur || 0), 0) || 0)
				    }    


					</span>
				</span>
				<span
					style={{
						color: '#838EAB',
						marginBottom: '1rem',

					}}
				>
					Documents :{' '}
					<span style={{ marginRight: 15,
												color: '#838EAB',
												fontWeight: 'bolder'}}>
					{commande.statut!=="annuler"  ? (commande?.files?.length || 0 + 
					commande?.missions
					?.filter(mission=>mission.statut!=="annuler")
					?.reduce((total, mission) => total + (mission.files?.length || 0), 0))
					:
					(commande?.files?.length || 0 + 
						commande?.missions
						?.reduce((total, mission) => total + (mission.files?.length || 0), 0))
					}

					</span>
				</span>
				<span
					style={{
						color: '#838EAB',
						marginBottom: '1rem',

					}}
				>
					{t("internal_refrence")} :{' '}
					<span style={{ marginRight: 15,
												color: '#838EAB',
												fontWeight: 'bolder' }}>
					{commande.ref_client}
					</span>
				</span>
                <span
					style={{
						color: '#838EAB',
						marginBottom: '1rem',

					}}
				>
					{t("total_km")} :{' '}
					<span style={{ marginRight: 15,
												color: '#838EAB',
												fontWeight: 'bolder'}}>
					{commande.distance}
					</span>
				</span>
				<span
						style={{
							color: '#838EAB',
							marginBottom: '.5rem',

						}}
					>
						{t("useful_note")}:{' '}
						<span style={{ marginRight: 15,
												color: '#838EAB',
												fontWeight: 'bolder' }}>
                         {commande.statut!=="annuler"? 
						 (commande?.missions
                         ?.filter(mission => mission.statut !== "annuler")
                         ?.some(mission => mission?.notes?.length > 0) ? t("yes") : t("no"))
						  :
						  (commande?.missions
							?.some(mission => mission?.notes?.length > 0) ? t("yes") : t("no"))
						 }
                         </span>

					</span>
				
			</div>

			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					// marginLeft:'0.5rem',
					// marginRight:'0.5rem',
					fontSize: 13,
				}}
			>
				{!hideTarif && (
				 <div
					style={{
						background: 'white',
						padding: '0.2rem .1rem',
						display: 'flex',
						flexDirection: 'row',
						color: '#838EAB',
						fontSize: 13,
						borderRadius: 5,
						marginBottom: 3,
					}}
				>
					<span
						style={{
							marginRight: 15,
							display: 'flex',
							flexDirection: 'column',
							fontWeight: 'bold',
							fontSize: 14,
							padding: '1rem 0.3rem',
						}}
					>
						<span>
							{t("total_amount")}:{' '}
							
							
							{
			                (commande?.prix_total ?
								((commande.prix_total) - ((commande.prix_total) * (commande.margin ?? 0) / 100)).toFixed(2)
							: 

                            ((commande.prix+totalForfaitsSupp) - ((commande.prix+totalForfaitsSupp) * (commande.margin ?? 0) / 100)).toFixed(2)
                            )}€
						</span>
					</span>
				</div> )}
				{!hideTarif && (
				 <div
					style={{
						background: 'white',
						padding: '0.2rem .2rem',
						display: 'flex',
						flexDirection: 'row',
						color: '#838EAB',
						fontSize: 13,
						borderRadius: 5,
						marginBottom: 3,
						marginTop:2
					}}
				>
					<span
						style={{
							marginRight: 15,
							display: 'flex',
							flexDirection: 'column',
							fontWeight: 'bold',
							fontSize: 14,
							padding: '1rem 0.3rem',
						}}
					>
						<span>
						{t("initial_amount")}:{' '}
							
						
							{
                             (commande.prix - (commande.prix * (commande.margin ?? 0) / 100)).toFixed(2)
                            }€
						</span>
					</span>
				</div> )}
				{!hideTarif && !commande?.prix_total && (
				 <div
					style={{
						background: 'white',
						padding: '0.2rem .2rem',
						display: 'flex',
						flexDirection: 'row',
						color: '#838EAB',
						fontSize: 13,
						borderRadius: 5,
						marginBottom: 3,
					}}
				>
					<span
						style={{
							marginRight: 15,
							display: 'flex',
							flexDirection: 'column',
							fontWeight: 'bold',
							fontSize: 14,
							padding: '1rem 0.3rem',
						}}
					>
						<span>
						{t("additional_flat_rate_amounts")}:{' '}
							{
                             (totalForfaitsSupp - (totalForfaitsSupp * (commande.margin ?? 0) / 100)).toFixed(2)
                            }€
						</span>
					</span>
				</div> 
			    )}
				{!hideTarif  && additionalCosts > 0 &&  (
				 <div
					style={{
						background: 'white',
						padding: '0.2rem .2rem',
						display: 'flex',
						flexDirection: 'row',
						color: '#838EAB',
						fontSize: 13,
						borderRadius: 5,
						marginBottom: 3,
					}}
				>
					<span
						style={{
							marginRight: 15,
							display: 'flex',
							flexDirection: 'column',
							fontWeight: 'bold',
							fontSize: 14,
							padding: '1rem 0.3rem',
						}}
					>
						<span>
						{t("additional_amount")}: 
							{
                             (additionalCosts - (additionalCosts * (commande.margin ?? 0) / 100)).toFixed(2)
                            }€
						</span>
					</span>
				</div> 
			    )}
			    
			
				
                
			</div>

			{/*  */}

			<div
				style={{
					color: '#838EAB',
					display: 'flex',
					flexDirection: 'column',
					fontSize: 13,
				}}
			>
				<span>
					{t("handling_eq1")}:{' '}
					<span style={{ marginRight: 15,
												color: '#838EAB',
												fontWeight: 'bolder'}}>
						{commande.manutention.includes('Diable') && t("yes")}
					</span>
				</span>
				<span>
					{t("handling_eq2")}:{' '}
					<span style={{marginRight: 15,
												color: '#838EAB',
												fontWeight: 'bolder'}}>
						{commande.manutention.includes('Transpalette manuel') &&
							t("yes")}
					</span>
				</span>
				<span>
					{t("handling_eq3")}:{' '}
					<span style={{ marginRight: 15,
												color: '#838EAB',
												fontWeight: 'bolder' }}>
						{commande.transpalette_électrique ? t("yes") :t("no")}
					</span>
				</span>
				<span>
					{t("handling_eq4")}:{' '}
					<span style={{ marginRight: 15,
												color: '#838EAB',
												fontWeight: 'bolder'}}>
						{commande.manutention.includes('Sangle') && t("yes")}
					</span>
				</span>

				<span>
					{t("ppe_eq1")}:{' '}
					<span style={{ marginRight: 15,
												color: '#838EAB',
												fontWeight: 'bolder' }}>
						{commande.epi.includes('Casque') && t("yes")}
					</span>
				</span>
				<span>
					{t("ppe_eq2")}:{' '}
					<span style={{ marginRight: 15,
												color: '#838EAB',
												fontWeight: 'bolder' }}>
						{commande.epi.includes('Gants') && t("yes")}
					</span>
				</span>
				<span>
					{t("ppe_eq3")}:{' '}
					<span style={{ marginRight: 15,
												color: '#838EAB',
												fontWeight: 'bolder'}}>
						{commande.epi.includes('Masque') && t("yes")}
					</span>
				</span>
				<span>
					{t("ppe_eq4")}:{' '}
					<span style={{ marginRight: 15,
												color: '#838EAB',
												fontWeight: 'bolder'}}>
						{commande.epi.includes('Lunettes') && t("yes")}
					</span>
				</span>
				<span>
					{t("ppe_eq5")}:{' '}
					<span style={{ marginRight: 15,
												color: '#838EAB',
												fontWeight: 'bolder' }}>
						{commande.epi.includes('Chaussure de sécurité') &&
							t("yes")}
					</span>
				</span>
				<span>
					{t("ppe_eq6")}:{' '}
					<span style={{ marginRight: 15,
												color: '#838EAB',
												fontWeight: 'bolder' }}>
						{commande.epi.includes('Gilet de visibilité') && t("yes")}
					</span>
				</span>
			</div>
			</div>

<div>
			<div
				style={{
					//width: '16%',
					display: 'flex',
					flexDirection: 'column',
					fontSize: 13,
					marginTop: 35,
				}}
			>
				{!hideRecu && !commande.recu && (
					<button
						onClick={onClickRecu}
						style={{
							cursor: 'pointer',
							fontFamily: 'Montserrat',
							background: '#50F5A9',
							color: 'white' ,
							border: 'none',
							fontWeight: 'bold',
							padding: '0.5rem 1.5rem',
							borderRadius: 4,
							marginTop: 5,
						}}
					>
						{t("accept_order")}
					</button>
				)}
                {!hideAttribuer && (
					<>

						<button
							onClick={onClickAttribuer}
							style={{
								padding: '0.5rem 1.5rem',
								background: '#fce399',
								border: 'none',
								cursor: 'pointer',
								color: 'white',
								borderRadius: 7,
								marginTop: 5,
								fontFamily: 'Montserrat',
								fontWeight: 'bold',
							}}
						>
							{t("mission_management")}
						</button>
					</>
				)}
				
				
				<button
					onClick={onClickDetails}
					style={{
						padding: '0.5rem 1.5rem',
						background: '#51C7F2',
						border: 'none',
						cursor: 'pointer',
						color: 'white',
						borderRadius: 7,
						marginTop: 5,
						fontFamily: 'Montserrat',
						fontWeight: 'bold',
					}}
				>
					{t("view_details")}
				</button>
				

				{ hideStatus && !hideSignaler &&
				<button
				onClick={onClickSignaler}
				style={{
					padding: '0.5rem 1.5rem',
					background: '#838EAB',
					border: 'none',
					cursor: 'pointer',
					color: 'white',
					borderRadius: 7,
					marginTop: 5,
					fontFamily: 'Montserrat',
					fontWeight: 'bold',
				}}
			>
				{t("reports")}
			   </button>
				}
			
					{(!hideRecu && !commande?.recu)&& (
					<button
						onClick={onClickRefuser}
						style={{
							cursor: 'pointer',
							fontFamily: 'Montserrat',
							background:'#f29393',
							color:  'white',
							border: 'none',
							fontWeight: 'bold',
							padding: '0.5rem 1.5rem',
							borderRadius: 4,
							marginTop: 5,
						}}
					>
						{t("reject")}
					</button>
					
				)}
				{!hideAccept && (
					<button
						onClick={onClickAccept}
						disabled={!commande?.canAccept} 
						style={{
							cursor: 'pointer',
							fontFamily: 'Montserrat',
							background: commande?.canAccept? '#50F5A9':'#838EAB',
							color: commande?.canAccept? 'white' :'#9EA8BF',
							border: 'none',
							fontWeight: 'bold',
							padding: '0.5rem 1.5rem',
							borderRadius: 4,
							marginTop: 5,
						}}
					>
						{t("accept")}
					</button>
				)}
				
			</div>
		</div>
		 
			
		</div>
	)
}

export default React.memo(MiseADispoHorizontal)
